/**
 * Rolling stock (traction) vs route competence vs rules/other.
 * Stored on each competency record in Azure JSON store as `competency_category`.
 * Legacy records without the field fall back to substring heuristics on `type`.
 */
export type CompetencyCategory = "traction" | "route" | "rules";

export function isTractionCompetency(c: {
  type?: string;
  competency_category?: string;
}): boolean {
  const cat = String(c.competency_category || "").toLowerCase();
  if (cat === "traction") return true;
  if (cat === "route" || cat === "rules") return false;
  const t = String(c.type || "");
  return t.includes("Class") || t.toLowerCase().includes("traction");
}

/** Route table: infrastructure / route competence (not rolling stock, not rules-only rows). */
export function isRouteCompetency(c: {
  type?: string;
  competency_category?: string;
}): boolean {
  const cat = String(c.competency_category || "").toLowerCase();
  if (cat === "route") return true;
  if (cat === "traction" || cat === "rules") return false;
  const t = String(c.type || "");
  if (t.includes("Class") || t.toLowerCase().includes("traction")) return false;
  if (t.includes("Rules")) return false;
  if (t.toLowerCase().includes("pts")) return false;
  return true;
}
